module.exports = __webpack_public_path__ + "static/media/10.93f709cb.png";